import { Alert, Autocomplete, Box, Button, Collapse, Grid, IconButton, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import jwt_decode from "jwt-decode";

import { useParams } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';
import TransferenciaDestino from "./TransferenciaDestino";

export default function Transferencias(props) {
    const token = sessionStorage.getItem('token')
    const decoded = jwt_decode(token);
    const idResponsable = decoded.id;
    const [anio, setAnio] = useState(null)
    const [proyectos, setProyectos] = useState([])
    const [proyectosRespaldo, setProyectosRespaldo] = useState([])
    const [proyecto, setProyecto] = useState(null)
    const [transferenciaOrigens, setTransferenciaOrigens] = useState([])
    const [entidad, setEntidad] = useState(null)
    const [entidadTemporal, setEntidadTemporal] = useState(null)
    //const [partidas, setPartidas] = useState([]);
    const [fechas, setFechas] = useState(null)
    const [partidasProyecto, setPartidasProyecto] = useState([])
    const [entidades, setEntidades] = useState([])
    const [partida, setPartida] = useState(null);
    const [monto, setMonto] = useState(null);
    const [id, setId] = useState(null);
    const [justificacion, setJustificacion] = useState('');
    const [observaciones, setObservaciones] = useState('');
    const [sinConfiguracionFechas, setSinConfiguracionFechas] = useState(false)
    const [errorProyectoSinPartidas, setErrorProyectoSinPartidas] = useState(false)
    const [helperTextProyectoSinPartidas, setHelperTextProyectoSinPartidas] = useState('')
    const [errorPartidaRepetida, setErrorPartidaRepetida] = useState(false)
    const [helperTextPartidaRepetida, setHelperTextPartidaRepetida] = useState('')
    const [errorEntidadSinProyectos, setEntidadSinProyectos] = useState(false)
    const [helperTextEntidadSinProyectos, setHelperTextEntidadSinProyectos] = useState('')
    const [errorMovimiento, setErrorMovimiento] = useState(false)
    const [transferenciasDestino, setTransferenciasDestino] = useState([])
    const [transferenciasDestinoEliminadas, setTransferenciasDestinoEliminadas] = useState([])
    const [transferenciasOrigenEliminadas, setTransferenciasOrigenEliminadas] = useState([])
    const [open, setOpen] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [expiroFecha, setExpiroFecha] = useState(false)
    const [solicitud, setSolicitud] = useState(null);
    const [indice, setIndice] = useState(1);
    const [severity, setSeverity] = useState('error')
    const [partidasModificadas, setPartidasModificadas] = useState([])
    const [loading, setLoading] = useState(false)

    const params = useParams()

    const cargarProyectos = async () => {

        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/informeProyecto/proyectos/${params.idResponsable ? params.idResponsable : solicitud ? solicitud.idSolicitante : idResponsable}/${false}/${sessionStorage.getItem('idEntidad')}`, { //Siempre es en gestión por eso se pone false
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })
        if (res.status === 404) {
            //console.log('regresó 404 en Transferencia') poner mensaje de error
            return
        }
        else {
            //console.log('si hay proyectos')
            const data = await res.json()
            //console.log(data)

            setProyectos(data)
            setProyectosRespaldo(data)

            const idPlan = data[0].idPlan
            //console.log(`IDPLAN ${data[0].idPlan}`)
            const resPlan = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/planeacion/${idPlan}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                }
            }
            )
            const plan = await resPlan.json()
            //console.log(`ANIO ${plan.anio}`)
            setAnio(plan.anio)
            await cargarFechas(plan.anio)
        }
    }

    const cargarFechas = async (anio) => {

        //console.log(`ENTIDAD ${sessionStorage.getItem('idEntidad')}`)
        const entidad = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/entidad/${sessionStorage.getItem('idEntidad')}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })
        const entidadLeida = await entidad.json()
        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/configuracionFechas/configuracion/${anio}/${entidadLeida.idEntidadSuperior ? entidadLeida.idEntidadSuperior : entidadLeida.id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })
        const fechasLeidas = await res.json()
        if (res.status === 404) {
            setMensaje('Aún no se ha establecido la configuración de fechas, solicite a la Asistencia Administrativa que la registre')
            setOpen(true)
            setSinConfiguracionFechas(true)
        }
        //console.log(`FECHAS LEIDAS ${fechasLeidas.activarMontosPrioridad2}`)
        setFechas(fechasLeidas)
        const fechaCierreTransferencias = new Date(fechasLeidas.cierreTransferencias)
        fechaCierreTransferencias.setDate(fechaCierreTransferencias.getDate() + 1);
        //console.log(`fechaCierreTransferencias ${fechaCierreTransferencias}`)                            
        if (Date.now() >= Date.parse(fechaCierreTransferencias)) {//console.log(`Entró a true ${Date.now()} --- ${Date.parse(fechaCierreTransferencias)}` )
            setExpiroFecha(true)
        }
        else {
            //console.log('entró a false')
            setExpiroFecha(false)
        }
    }

    const { idSolicitud, seEnviaCorreo, setIdSolicitud, verificarDisponible } = props;

    useEffect(() => {
        (async () => {
            const resLeer = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/entidad/`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                }
            })
            const entidadesLeidas = await resLeer.json()
            //console.log(`entidadesLeidas ${JSON.stringify(entidadesLeidas)}`)
            setEntidades(entidadesLeidas)
            setEntidadTemporal(entidadesLeidas.filter(entidad => Number(entidad.id) === Number(sessionStorage.getItem('idEntidad')))[0])
            if (idSolicitud) {
                const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/transferencias/solicitudTransferencias/${idSolicitud}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": sessionStorage.getItem('token'),
                        "perfil": sessionStorage.getItem('perfil')
                    }
                })
                const solicitud = await res.json()

                //console.log(`solicitud ${JSON.stringify(solicitud)}`)

                await Promise.all(solicitud.transferenciaDestinos.map(async (transferencia) => {
                    const resPartida = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/partidasProyecto/${transferencia.idPartidaProyecto}`, {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            "x-access-token": sessionStorage.getItem('token'),
                            "perfil": sessionStorage.getItem('perfil')
                        }
                    })
                    transferencia.partida = await resPartida.json()
                    let montoOrigenes = 0
                    await Promise.all(transferencia.transferenciaOrigens.map(async (origen) => {
                        const resPartida = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/partidasProyecto/${origen.idPartidaProyecto}`, {
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                "x-access-token": sessionStorage.getItem('token'),
                                "perfil": sessionStorage.getItem('perfil')
                            }
                        })
                        origen.partida = await resPartida.json()
                        montoOrigenes = (Number(montoOrigenes) + Number(origen.monto)).toFixed(2)
                        const resProyecto = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/proyectosPlan/proyecto/${origen.partida.idProyectoPlan}`, {
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                "x-access-token": sessionStorage.getItem('token'),
                                "perfil": sessionStorage.getItem('perfil')
                            }
                        })
                        origen.proyecto = await resProyecto.json()
                    }))
                    transferencia.monto = montoOrigenes
                }))

                setTransferenciasDestino(solicitud.transferenciaDestinos)
                setSolicitud(solicitud)
                //console.log(`solicitud dentro de useEffect cuando cambió el idSolicitud ${JSON.stringify(solicitud)}`)
            }

            await cargarProyectos()
        })()
        // eslint-disable-next-line
    }, [idSolicitud])

    const handleSolicitarTransferencia = async (e) => {
        e.preventDefault()
        setLoading(true)
        let error = false
        transferenciasDestino.map(async (transferencia) => {
            if (Number(transferencia.monto) === Number(0)) {
                setSeverity('error')
                setOpen(true)
                error = true
                setMensaje('Existen partidas de destino sin partidas origen, capture la(s) partida(s) de origen o elimine la(s) partida(s) de destino innecesaria(s).')
                setLoading(false)
                return
            }
        })
        if (error){
            setLoading(false)
            return
        }
        if (idSolicitud) {
            const resActualizar = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/transferencias/${idSolicitud}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                },
                body: JSON.stringify({
                    idSolicitud,
                    idSolicitante: idResponsable,
                    anio,
                    transferenciasDestino,
                    transferenciasDestinoEliminadas,
                    transferenciasOrigenEliminadas,
                    partida,
                    idEntidad: sessionStorage.getItem('idEntidad'),
                    seEnviaCorreo
                })
            })
            if (resActualizar.status === 200)
                setSeverity('success')
            else{
                setSeverity('error')
                setLoading(false)
            }
            /*console.log(`TRANSFERENCIAS MODIFICADAS ${JSON.stringify({
                idSolicitud,
                idSolicitante: idResponsable,
                anio,
                transferenciasDestino
            })}`)*/
            const data = await resActualizar.json()
            if (data.message) {
                setOpen(true)
                setMensaje(data.message)
                return
            }
            else {
                setOpen(true)
                setMensaje("Se actualizó la solicitud")
            }
        }
        else {
            transferenciasDestino.map(async (transferencia) => {
                transferencia.id = null
            })
            const resGuardar = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/transferencias/guardarTransferencia`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                },
                body: JSON.stringify({
                    idSolicitante: idResponsable,
                    anio,
                    transferenciasDestino,
                    idEntidad: sessionStorage.getItem('idEntidad'),
                    seEnviaCorreo
                })
            })


            const data = await resGuardar.json()
            if (resGuardar.status === 200) {
                setSeverity('success')
                setTransferenciasDestino(data.solicitud.transferenciaDestinos)
                setIdSolicitud(data.solicitud.id)
            }
            else{
                setSeverity('error')
                setLoading(false)
            }
            if (data.message) {
                setOpen(true)
                setMensaje(data.message)
                return
            }
            else {
                setOpen(true)
                setMensaje("Se registró la solicitud")
            }
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (!errorPartidaRepetida) {
            // if (movimiento.label === 'Origen') {
            proyecto.partidaProyectos = null

            // const transferenciaOrigen = { id, monto, idPartidaProyecto: partida.idPartidaProyecto, partida: { ...partida }, proyecto: { ...proyecto } }
            //console.log(`errorPartidaRepetida ${errorPartidaRepetida} !errorPartidaRepetida ${!errorPartidaRepetida}`)
            /*if (idSolicitud && transferenciaOrigen.id) {
                const index = transferenciasOrigen.findIndex(transferenciasOrigen => String(transferenciasOrigen.id) === String(transferenciaOrigen.id));
                console.log(`INDEX ${index}`)
                // OJO transferenciaOrigen.id = transferenciasOrigen[index].id
                if (index !== -1)
                    transferenciasOrigen.splice(index, 1);
                // setTransferenciasOrigen(transferenciasOrigen.filter(transferenciasOrigen => transferenciasOrigen.idPartidaProyecto !== transferenciaOrigen.idPartidaProyecto))
                transferenciasOrigen.push(transferenciaOrigen)
                setHelperTextPartidaRepetida('')
                setErrorPartidaRepetida(false)
            }
            else {
                if (transferenciaOrigen.id === null) {
                    transferenciaOrigen.id = `id${indice}`
                    setIndice(indice + 1)
                }
                const index = transferenciasOrigen.findIndex(transferenciasOrigen => String(transferenciasOrigen.id) === String(transferenciaOrigen.id));
                console.log(`INDEX ${index}`)
                // OJO transferenciaOrigen.id = transferenciasOrigen[index].id
                if (index !== -1)
                    transferenciasOrigen.splice(index, 1);
                transferenciasOrigen.push({ ...transferenciaOrigen })
                console.log(`Transferencias guardadas ${JSON.stringify(transferenciasOrigen)}`)
                if (transferenciasDestino.length > 0)
                    transferenciasDestino[0].monto = (Number(transferenciasDestino[0].monto) + Number(transferenciaOrigen.monto)).toFixed(2)
            }*/
            /*}
            else {*/
            proyecto.partidaProyectos = null

            const transferenciaDestino = { id, monto, idPartidaProyecto: partida.idPartidaProyecto, partida: { ...partida }, proyecto: { ...proyecto }, justificacion, observaciones, entidad: entidad ? { ...entidad } : { ...entidadTemporal }, expanded: true, transferenciaOrigens }

            //console.log(`transferenciaDestino ${JSON.stringify(transferenciaDestino)}`)
            //let modificando = false
            /*if (idSolicitud) {  
                if (transferenciaDestino.id) {
                    modificando = true
                }              
                //transferenciasDestino.pop()
            }
            else {
                if (transferenciaDestino.id) {
                    modificando = true
                }
                else {
                    transferenciaDestino.id = `id${indice}`
                    //transferenciasDestino.pop()
                    setIndice(indice + 1)
                }
            }*/
            if (transferenciaDestino.id) {
                //modificando = true
            }
            else {
                transferenciaDestino.id = `id${indice}`
                //transferenciasDestino.pop()
                setIndice(indice + 1)
            }
            const existePartida = transferenciasDestino.filter(transferencia => transferencia.idPartidaProyecto === transferenciaDestino.idPartidaProyecto)
            if (existePartida.length > 0 && existePartida[0].id !== transferenciaDestino.id) {
                setMensaje('Esa partida ya está registrada')
                setOpen(true)
            }
            else {
                const transferenciasFiltradas = transferenciasDestino.filter(transferencia => transferencia.id !== transferenciaDestino.id)
                // console.log(`transferenciasFiltradas antes del push ${JSON.stringify(transferenciasFiltradas)}`)
                transferenciasFiltradas.push({ ...transferenciaDestino })
                // console.log(`transferenciasFiltradas después del push ${JSON.stringify(transferenciasFiltradas)}`)
                setTransferenciasDestino([...transferenciasFiltradas])
            }
            //}

            setPartida(null)
            setMonto(null)
            setId(null)
            //console.log(` valor filtrado ${entidades.filter(entidad => Number(entidad.id) === Number(sessionStorage.getItem('idEntidad')))[0]}`)
            // DEJAR LA ENTIDAD SELECCIONADA POR EL USUARIO setEntidad(entidades.filter(entidad => Number(entidad.id) === Number(sessionStorage.getItem('idEntidad')))[0])
            setProyecto(null)
            setJustificacion('')
            setObservaciones('')
            setPartidasProyecto([])
            setTransferenciaOrigens([])
        }
    }

    const handleDeleteDestino = async (registro) => {
        //console.log(`registro ${JSON.stringify(registro)}`)
        //setTransferenciasOrigen(transferenciasOrigen.filter(transferenciasOrigen => Number(transferenciasOrigen.idPartidaProyecto) !== Number(registro.idPartidaProyecto)))
        setTransferenciasDestino(transferenciasDestino.filter(transferenciasDestino => Number(transferenciasDestino.idPartidaProyecto) !== Number(registro.idPartidaProyecto)))
        //console.log(`registro.id ${registro.id}`)
        transferenciasDestinoEliminadas.push(registro.id)
        setHelperTextPartidaRepetida('')
        setErrorPartidaRepetida(false)

    }

    const handleDeleteOrigen = async (registro) => {
        //console.log(`registro ${JSON.stringify(registro)}`)
        //setTransferenciasOrigen(transferenciasOrigen.filter(transferenciasOrigen => Number(transferenciasOrigen.idPartidaProyecto) !== Number(registro.idPartidaProyecto)))
        const transferenciaDestino = transferenciasDestino.filter(transferenciasDestino => Number(transferenciasDestino.id) === Number(registro.idDestino))
        //setTransferenciasDestino(transferenciasDestino.filter(transferenciasDestino => Number(transferenciasDestino.idPartidaProyecto) !== Number(registro.idPartidaProyecto)))
        //console.log(`transferenciaDestino filtrada ${JSON.stringify(transferenciaDestino)}`)
        transferenciasOrigenEliminadas.push(registro.id)
        setHelperTextPartidaRepetida('')
        setErrorPartidaRepetida(false)
        if (transferenciaDestino.length > 0) {
            transferenciaDestino[0].monto = Number(transferenciaDestino[0].monto) - Number(registro.monto)
            const origenesFiltrados = transferenciaDestino[0].transferenciaOrigens.filter(transferenciaOrigen => Number(transferenciaOrigen.id) !== Number(registro.id))
            transferenciaDestino[0].transferenciaOrigens = origenesFiltrados
            //Es necesario para que se vea el cambio y se actualice el elemento correspondiente
            const transferenciasActualizadas = transferenciasDestino.map(transferencia => {
                if (transferencia.id === transferenciaDestino[0].id) {
                    // Encontrar el destino al que corresponde el origen eliminado, se copia y
                    // se actualiza la propiedad `transferenciaOrigens` de ese destino
                    return {
                        ...transferencia,
                        transferenciaOrigens: origenesFiltrados
                    };
                }

                return transferencia;
            });

            setTransferenciasDestino(transferenciasActualizadas)

            //console.log(`Eliminadas ${transferenciasOrigenEliminadas}`)
        }
    }

    /*const handleDelete = async (registro) => {
        console.log(`registro ${JSON.stringify(registro)}`)
        //setTransferenciasOrigen(transferenciasOrigen.filter(transferenciasOrigen => Number(transferenciasOrigen.idPartidaProyecto) !== Number(registro.idPartidaProyecto)))
        setTransferenciasDestino(transferenciasDestino.filter(transferenciasDestino => Number(transferenciasDestino.idPartidaProyecto) !== Number(registro.idPartidaProyecto)))
        console.log(`registro.id ${registro.id}`)
        //transferenciasEliminadas.push(registro.id)
        setHelperTextPartidaRepetida('')
        setErrorPartidaRepetida(false)
        if (transferenciasDestino.length > 0) {
            transferenciasDestino[0].monto = Number(transferenciasDestino[0].monto) - Number(registro.monto)
            console.log(`Se restó`)
        }
    }*/

    const cargarPartidasProyecto = async (proyecto) => {
        if (proyecto) {
            const res2 = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/partidasProyecto/proyecto/${proyecto.id}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                }
            })
            const partidasProyectoLectura = await res2.json()
            //console.log(`partidasProyectoLectura ${JSON.stringify(partidasProyectoLectura)}`)
            //Mostrar sólo las no 5000
            //console.log(`transferenciasDestino.clave ${JSON.stringify(transferenciasDestino[0].partida.clave)}`)

            setPartidasProyecto(partidasProyectoLectura)

            if (partidasProyectoLectura && partidasProyectoLectura.length > 0) {
                setErrorProyectoSinPartidas(false)
                setHelperTextProyectoSinPartidas('')
            }
            else {
                setErrorProyectoSinPartidas(true)
                setHelperTextProyectoSinPartidas('Este proyecto no tiene partidas')
            }
        }
    }

    const handleUpdate = async (transferencia) => {
        //console.log(`transferencia a modificar ${JSON.stringify(transferencia)}`)
        /*let esDestino = false;
        console.log(`transferencia.id ${transferencia.id}`)
        transferenciasDestino.map((transferenciaDestino) => {
            if (String(transferencia.id) === String(transferenciaDestino.id))
                esDestino = true;

        })*/

        /*if (esDestino) {
            setMovimiento({ id: 'destino', label: 'Destino' })*/
        /*const resLeer = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/entidad/`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })
        const entidadesLeidas = await resLeer.json()
        //console.log(`entidadesLeidas ${JSON.stringify(entidadesLeidas)}`)
        setEntidades(entidadesLeidas)*/
        /* }
         else
             setMovimiento({ id: 'origen', label: 'Origen' })*/

        /*const resPartida = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/partidasProyecto/${transferencia.idPartidaProyecto}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })
        transferencia.partida = await resPartida.json()
        ///falta poner la partida con setPartida
        const resProyecto = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/proyectosPlan/proyecto/${transferencia.partida.idProyectoPlan}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })
        transferencia.proyecto = await resProyecto.json()
        await cargarPartidasProyecto(transferencia.proyecto)
        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/entidad/${transferencia.proyecto.idEntidad}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })

        const entidad = await res.json()
        setEntidad(entidad)
        if (esDestino)
            setTransferenciasDestino({ ...transferenciasDestino, entidad })*/
        await cargarPartidasProyecto(transferencia.proyecto)
        setProyecto(transferencia.proyecto)
        setPartida(transferencia.partida)
        setJustificacion(transferencia.justificacion)
        setObservaciones(transferencia.observaciones)
        setMonto(transferencia.monto)
        setId(transferencia.id)
        setTransferenciaOrigens(transferencia.transferenciaOrigens)
    }


    return (
        <><Grid container justifyContent='stretch' spacing={5} style={{ marginTop: 5 }}>
            <Grid item xs={12} sm={6}>
                {expiroFecha ? <Typography component='span' style={{ color: 'rgb(156, 39, 176)', fontSize: 'inherit' }}><br />La fecha límite para el registro de solicitudes de transferencia ha expirado.</Typography> :
                    <form onSubmit={handleSubmit}>
                        <Grid container justifyContent='stretch' spacing={5} style={{ marginTop: 5 }}>
                            <Grid item xs={12} sm={12}>
                                <h4 style={{ textAlign: 'center', color: '#b22dca' }}>Registro de partidas de destino</h4>
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <Autocomplete
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    getOptionLabel={(option) => option.nombre}
                                    value={entidad ? entidad : null}
                                    onChange={async (event, newValue) => {
                                        setEntidad(newValue)
                                        //console.log(`newValue ${JSON.stringify(newValue)}`)
                                        // console.log(`RESPONSABLE de entidad ${newValue?newValue.perfil.idEmpleado:newValue}`)
                                        setPartida(null)
                                        setProyecto(null)
                                        setPartidasProyecto(null)
                                        if (newValue) {
                                            if (!newValue.perfil) {
                                                setPartida(null)
                                                setProyecto(null)
                                                setPartidasProyecto(null)
                                                setEntidadSinProyectos(true)
                                                setHelperTextEntidadSinProyectos('La entidad seleccionada no tiene una persona a cargo')
                                                return
                                            }
                                            const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/planeacion/byUser/${newValue.perfil.idEmpleado}/false/${newValue.id}`, {   //Las transferencias solo suceden en la gestion nunca en la planeación por eso se da false
                                                method: "GET",
                                                headers: {
                                                    "Content-Type": "application/json",
                                                    "x-access-token": sessionStorage.getItem('token'),
                                                    "perfil": sessionStorage.getItem('perfil')
                                                }
                                            }
                                            )
                                            if (res.status === 404) {
                                                setEntidadSinProyectos(true)
                                                setHelperTextEntidadSinProyectos('La entidad seleccionada no tiene proyectos registrados')
                                                return
                                            }

                                            const data = await res.json()

                                            if (data.proyectoPlans) {
                                                setProyectos(data.proyectoPlans)
                                                setEntidadSinProyectos(false)
                                                setHelperTextEntidadSinProyectos('')
                                            }
                                            else {
                                                setEntidadSinProyectos(true)
                                                setHelperTextEntidadSinProyectos('La entidad seleccionada no tiene proyectos registrados')
                                            }
                                            //console.log(`PROYECTOS ${data.proyectoPlans}`)
                                        }
                                        else {
                                            setProyectos(proyectosRespaldo)
                                        }
                                    }
                                    }
                                    name="entidad"
                                    options={entidades}
                                    sx={{ width: '100%' }}
                                    renderInput={(params) => <TextField {...params} label={`Entidad destino`} focused multiline helperText={helperTextEntidadSinProyectos} error={errorEntidadSinProyectos} />}
                                />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                {!errorMovimiento && !errorEntidadSinProyectos ?
                                    <>
                                        <Autocomplete
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                            getOptionLabel={(option) => option.clave + '-' + option.descripcion}
                                            value={proyecto ? proyecto : null}
                                            onChange={async (event, newValue) => {
                                                //console.log(newValue)
                                                setProyecto(newValue)
                                                setPartida(null)
                                                await cargarPartidasProyecto(newValue)

                                            }}
                                            id="proyecto"
                                            name="proyecto"
                                            options={proyectos}
                                            sx={{ width: '100%' }}
                                            renderInput={(params) => <TextField {...params} label={`Proyecto destino`} focused required helperText={helperTextProyectoSinPartidas} error={errorProyectoSinPartidas} multiline />}
                                        />
                                    </>
                                    : <></>}
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                {partidasProyecto ? partidasProyecto.length > 0 ?
                                    <Autocomplete
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        getOptionLabel={(option) => option.clave + '-' + option.concepto}
                                        value={partida ? partida : null}
                                        onChange={async (event, newValue) => {
                                            //console.log(`newValue ${newValue}`)
                                            setPartida(newValue)
                                            setHelperTextPartidaRepetida('')
                                            setErrorPartidaRepetida(false)
                                        }}
                                        id="partida"
                                        name="partida"
                                        options={partidasProyecto}
                                        sx={{ width: '100%' }}
                                        renderInput={(params) => <TextField {...params} label={`Partida destino`} focused required helperText={helperTextPartidaRepetida} error={errorPartidaRepetida} multiline />}
                                    />
                                    : <></> : <></>}

                            </Grid>


                            <Grid item xs={12} sm={6}>
                                <TextField sx={{ width: '100%' }} focused multiline maxRows={5} name='justificacion' label="Justificación" onChange={(e) => {
                                    const valor = e.target.value
                                    setJustificacion(valor)

                                }} value={justificacion} />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField sx={{ width: '100%' }} focused multiline maxRows={5} name='observaciones' label="Observaciones" onChange={(e) => {
                                    const valor = e.target.value
                                    setObservaciones(valor)

                                }} value={observaciones} />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <Button variant='contained' color='primary' type='submit'>
                                    Guardar destino
                                </Button>
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <Button type='reset' variant='contained' color='error' onClick={() => { setPartida(null); setMonto(null); setId(null); setProyecto(null); setJustificacion(''); setObservaciones(''); setPartidasProyecto([]); setTransferenciaOrigens([]) }}>Limpiar</Button>
                            </Grid>

                        </Grid>
                        {/*transferenciasOrigen.length > 0 && transferenciasDestino.length > 0 && !sinConfiguracionFechas ? <Grid item><Button variant='contained' style={{ marginTop: 20, backgroundColor: "darkgreen", color: 'white' }} type='button' onClick={handleSolicitarTransferencia} >
                        {`${idSolicitud ? 'Actualizar' : 'Solicitar'} Transferencia`}
                    </Button></Grid> : <></>*/}
                    </form>
                }
            </Grid>
            <Grid item xs={12} sm={6}>
                <Grid container justifyContent='stretch' spacing={5} style={{ marginTop: 5 }}>
                    {transferenciasDestino.length > 0 ? transferenciasDestino.map((destino) => (
                        <Grid item xs={12} sm={12}>
                            <TransferenciaDestino idSolicitud={idSolicitud} destino={destino} transferenciasDestino={transferenciasDestino}
                                setTransferenciasDestino={setTransferenciasDestino} key={destino.partida.idPartidaProyecto}
                                partidasModificadas={partidasModificadas} setPartidasModificadas={setPartidasModificadas}
                                handleUpdateDestino={handleUpdate}
                                handleDeleteDestino={handleDeleteDestino}
                                handleDeleteOrigen={handleDeleteOrigen} verificarDisponible={verificarDisponible}></TransferenciaDestino>
                        </Grid>
                    )) : <></>
                    }
                </Grid>
            </Grid>
            <Grid item xs={12} sm={12}>
                <Box sx={{ width: '100%' }}>
                    <Collapse in={open}>
                        <Alert severity={severity}
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setOpen(false);
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }

                        >
                            {mensaje}
                        </Alert>
                    </Collapse>
                </Box>
            </Grid>
        </Grid>
            <Box sx={{ width: '100%', textAlign: 'center', marginTop: 5 }}>
                <Button type='button' variant='contained' color="success" onClick={handleSolicitarTransferencia} disabled={transferenciasDestino.length === 0 || loading}>{`${idSolicitud ? 'Actualizar' : 'Solicitar'} transferencia`}</Button>
            </Box>
        </>
    )
}
